/**
 * Vuetify nemá globální prop pro wheel na type="number".
 * Doporučený postup (komunita / blog): @wheel="$event.target.blur()" —
 * pole ztratí fokus, číslo se nezmění a stránka může normálně scrollovat.
 *
 * @see https://blog.digital-craftsman.de/disable-change-on-scroll-for-number-field-with-vue/
 */
export function blurNumberInputOnWheel(event) {
  const target = event.target
  if (target instanceof HTMLInputElement && target.type === 'number') {
    target.blur()
  }
}

export default {
  install() {
    document.addEventListener('wheel', blurNumberInputOnWheel, {
      passive: true,
      capture: true,
    })
  },
}
